export default __webpack_public_path__ + "static/media/imgActivity8-10.0d450a34.png";